/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export var BrowserType;
(function (BrowserType) {
    BrowserType["Chrome"] = "chrome";
    BrowserType["Chromium"] = "chromium";
    BrowserType["Edge"] = "edge";
    BrowserType["EdgeChromium"] = "edgeChromium";
    BrowserType["Firefox"] = "firefox";
    BrowserType["InternetExplorer"] = "internetExplorer";
    BrowserType["Safari"] = "safari";
})(BrowserType || (BrowserType = {}));
//# sourceMappingURL=BrowserType.js.map